export const SETTLEMENT_DETAIL_TAB = {
  DETAILS: 'details',
  DOCUMENTS: 'documents',
  PAYMENT_BREAKDOWN: 'payment_breakdown',
  DELIVERED_PRODUCTS: 'delivered_products',
  CANCELLED: 'cancelled',
  REFUND_PRODUCTS: 'refund_products'
}

export const SETTLEMENT_DETAIL_TABS = {
  DETAILS: { value: SETTLEMENT_DETAIL_TAB.DETAILS, label: 'Detalles', icon: 'info' },
  DOCUMENTS: {
    value: SETTLEMENT_DETAIL_TAB.DOCUMENTS,
    label: 'Documentos',
    icon: 'description'
  },
  PAYMENT_BREAKDOWN: {
    value: SETTLEMENT_DETAIL_TAB.PAYMENT_BREAKDOWN,
    label: 'Desglose de pagos',
    icon: 'credit_card'
  },
  DELIVERED_PRODUCTS: {
    value: SETTLEMENT_DETAIL_TAB.DELIVERED_PRODUCTS,
    label: 'Productos entregados',
    icon: 'check_circle'
  },
  CANCELLED: {
    value: SETTLEMENT_DETAIL_TAB.CANCELLED,
    label: 'Anulados',
    icon: 'cancel'
  },
  REFUND_PRODUCTS: {
    value: SETTLEMENT_DETAIL_TAB.REFUND_PRODUCTS,
    label: 'Productos rechazados',
    icon: 'menu'
  }
}

export const BASE_SETTLEMENT_DETAIL_TABS = [
  SETTLEMENT_DETAIL_TABS.DETAILS,
  SETTLEMENT_DETAIL_TABS.DOCUMENTS,
  SETTLEMENT_DETAIL_TABS.PAYMENT_BREAKDOWN,
  SETTLEMENT_DETAIL_TABS.DELIVERED_PRODUCTS
]

export const CANCELLED_SETTLEMENT_DETAIL_TAB = SETTLEMENT_DETAIL_TABS.CANCELLED

export const REFUND_PRODUCTS_SETTLEMENT_DETAIL_TAB = SETTLEMENT_DETAIL_TABS.REFUND_PRODUCTS

export const APPROVAL_STATUS = {
  SENT: 'sent',
  RECEIVED: 'received',
  PENDING: 'document_pending',
  INSERTED_ERP: 'inserted_erp'
}

export const ERP_SEND_STATUS = {
  FAILED: 'failed'
}

export const DEPOSIT_BALANCE_STATUS = {
  BALANCED: 'balanced',
  UNBALANCED: 'unbalanced'
}

export const APPROVAL_STATUS_UI = {
  [APPROVAL_STATUS.SENT]: {
    label: 'ENVIADO',
    className: 'settlement-sent-style',
    color: '#0C9ADE',
    backgroundColor: '#E4F4FB'
  },
  [APPROVAL_STATUS.RECEIVED]: {
    label: 'RECIBIDO',
    className: 'received-style',
    color: '#087E3B',
    backgroundColor: '#C4EAD4'
  },
  [APPROVAL_STATUS.PENDING]: {
    label: 'PENDIENTE',
    className: 'oc-pending-style',
    color: '#E96008',
    backgroundColor: '#F8CBAE'
  },
  [APPROVAL_STATUS.INSERTED_ERP]: {
    label: 'INSERTADO',
    className: 'inserted-style',
    color: '#087E3B',
    backgroundColor: '#C4EAD4'
  }
}

export const PAYMENT_BREAKDOWN_STATUS_UI = {
  ACTIVE: {
    label: 'VIGENTE',
    className: 'received-style'
  },
  CANCELLED: {
    label: 'ANULADO',
    className: 'annulled-style'
  }
}

export const PAYMENT_METHODS = [
  {
    key: 'cash',
    label: 'Efectivo',
    icon: 'payments',
    amountPaths: ['payment_method_totals.cash', 'cash_amount']
  },
  {
    key: 'cheque',
    label: 'Cheque',
    icon: 'receipt_long',
    amountPaths: ['payment_method_totals.cheque', 'cheque_amount']
  },
  {
    key: 'bank_deposit',
    label: 'Depósito bancario',
    icon: 'account_balance',
    amountPaths: ['payment_method_totals.bank_deposit', 'deposit_amount']
  },
  {
    key: 'digital_payment',
    label: 'Pago digital',
    icon: 'account_balance',
    amountPaths: ['payment_method_totals.digital_payment', 'payment_digital_amount']
  },
  {
    key: 'transfer',
    label: 'Transferencia',
    icon: 'sync_alt',
    amountPaths: ['payment_method_totals.transfer', 'transference_amount']
  },
  {
    key: 'credit_card',
    label: 'Tarjeta de crédito',
    icon: 'credit_card',
    amountPaths: ['payment_method_totals.credit_card', 'credit_card_amount']
  },
  {
    key: 'vale_digital',
    label: 'Vale digital',
    icon: 'smartphone',
    amountPaths: ['payment_method_totals.vale_digital', 'vale_digital_amount']
  }
]
